url = window.URL ? window.webkitURL
getUserMedia =
  if navigator.getUserMedia?
    navigator.getUserMedia.bind(navigator)
  else if navigator.webkitGetUserMedia
    navigator.webkitGetUserMedia.bind(navigator)
  else
    null

module.exports = new class
  constructor: ->
    @stream = null

  supportsGetUserMedia: ->
    getUserMedia?

  connected: ->
    @stream?

  getStream: ->
    @stream

  getStreamUrl: ->
    url.cre

  getError: -> @error

  connect: (next) ->
    if @stream?
      return next(null, @stream)

    @error = null

    err = (error) =>
      @error = error
      @stream = null
      next("Could not connect")

    settings = { video: true }

    getUserMedia settings, (stream) =>
      @_setRawStream(stream)
      @stream = url.createObjectURL(stream)
      next(null, @stream)
    , err

  _setRawStream: (rawStream) ->
    # If we happen to already have a stream, make sure we stop it, so the camera light doesn't stay on
    # (This might happen if we called connect multiple times)
    @stop()
    @rawStream = rawStream

  stop: ->
    if @rawStream?
      @rawStream.stop?()
      # Chrome deprecated and then removed the stream::stop method
      # https://developers.google.com/web/updates/2015/07/mediastream-deprecations
      @rawStream.getTracks?()?[0]?.stop?()
    @stream = null
    @rawStream = null



// WEBPACK FOOTER //
// ./app/scripts/views/camera/camera.coffee